import { Component } from "react";
import { C } from "../tokens";

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: C.cream, textAlign: "center", padding: "40px" }}>
        <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(60px,10vw,120px)", fontWeight: 900, color: `${C.crimson}10`, lineHeight: 1 }}>✦</div>
        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "32px", fontWeight: 700, color: C.deep, margin: "0 0 16px" }}>Something went wrong.</h2>
        <p style={{ fontFamily: "'Outfit',sans-serif", fontSize: "15px", color: C.muted, marginBottom: "32px", fontWeight: 300 }}>Please refresh the page, or come back in a moment.</p>
        <a href="/" style={{ background: `linear-gradient(135deg,${C.deep},${C.light})`, color: C.gold, padding: "14px 40px", fontFamily: "'Outfit',sans-serif", fontSize: "11px", fontWeight: 600, textDecoration: "none", letterSpacing: "2px", textTransform: "uppercase" }}>← Back Home</a>
      </div>
    );
  }
}
